import type { ToastProps } from "@/marketplace/toast";
import { pageProfiles, workspacePath } from "@/route";
import { i18n } from "@lingui/core";
import { t } from "@lingui/core/macro";
import type { SlimProfile } from "@mm/metx-workbench.meteomatics.com";

export function buildAddDashboardSuccessToast(
  dashboardTitle: string,
  copiedProfile: SlimProfile,
  routePrefix: string,
): Omit<ToastProps, "onDismiss"> {
  const profilesPath = `${routePrefix}${pageProfiles.asString()}`;
  const tabId = copiedProfile.tab_active ?? copiedProfile.tabs[0]?.id;
  const href = tabId == null ? profilesPath : `${routePrefix}${workspacePath(routePrefix, copiedProfile.id, tabId)}`;

  return {
    variant: "success",
    title: i18n._("marketplace.add-success-toast.title", { dashboardTitle }),
    description:
      tabId == null
        ? t({
            id: "marketplace.add-success-toast.description-no-tab",
            message: "Open My Dashboards to view it →",
          })
        : t({
            id: "marketplace.add-success-toast.description",
            message: "Click to go to My Dashboards →",
          }),
    href,
  };
}

export function buildAddDashboardErrorToast(description?: string): Omit<ToastProps, "onDismiss"> {
  return {
    variant: "error",
    title: t({
      id: "marketplace.add-error-toast.title",
      message: "Could not add dashboard",
    }),
    description:
      description ??
      t({
        id: "marketplace.add-error-toast.description",
        message: "Please try again in a moment.",
      }),
  };
}
